import { Button, Callout, Classes, Intent } from '@blueprintjs/core';
import cx from 'clsx';

import image from '../../../images/vitalstatistix-shield.gif';

import './styles.scss';

type Props = Readonly<{
  onSignIn: () => void;
  slackURL?: string;
  slackChannelName?: string;
  troubleshootingURL?: string;
}>;

export const SignIn = ({ onSignIn, slackURL, slackChannelName, troubleshootingURL }: Props) => (
  <div className="SignIn">
    <div className="SignIn-inner">
      <img className="SignIn-image" src={image} alt="" />
      <Button intent={Intent.PRIMARY} className="pt-large xpt-minimal" onClick={() => onSignIn()}>
        Sign in with Okta SSO
      </Button>
    </div>

    <Callout title="Are you having trouble signing in?" className={cx('SignIn-callout', Classes.RUNNING_TEXT)}>
      Visit the <a href={troubleshootingURL}>troubleshooting page on Confluence</a> or 👋 in{' '}
      <a href={slackURL}>#{slackChannelName}</a> on Slack.
    </Callout>
  </div>
);
